import httpClient from '@/services/httpClient'
import {AxiosResponse} from 'axios'
import {
  AxiosRequestMoveHex,
  AxiosRequestObjectCollectInterface,
  AxiosResponseAdvisorWithCoordinatesInterface,
  AxiosResponseCheckAdvisorInterface,
  CollectionInterface,
  DataOfHexInterface,
  InformationOfHex,
  ObjectOfMapInterface,
} from '@/types/types'

const MapService = {
  getPolygons: (
    minLon: number,
    maxLon: number,
    minLat: number,
    maxLat: number,
    zoom: number
  ): Promise<AxiosResponse<{bounds: DataOfHexInterface[]}>> =>
    httpClient.get('/hexagons/bounds', {
      params: {
        min_lon: minLon,
        max_lon: maxLon,
        min_lat: minLat,
        max_lat: maxLat,
        zoom: zoom,
      },
    }),
  getGlobalPolygons: (): Promise<
    AxiosResponse<{bounds: DataOfHexInterface[]}>
  > => httpClient.get('/hexagons/global-hexes'),
  checkAdvisor: (data: {
    hex_ids: string[]
    has_my_hex?: boolean
  }): Promise<
    AxiosResponse<{
      advisors: AxiosResponseCheckAdvisorInterface[]
    }>
  > => httpClient.post(`/lands/buy/check-advisor`, data),
  getCenter: (hexId: string): Promise<AxiosResponse<{x: number; y: number}>> =>
    httpClient.get(`/hexagons/${hexId}/center`),
  getObjects: (
    type: string
  ): Promise<
    AxiosResponse<{
      all_objects: ObjectOfMapInterface[]
      default_octa_coins: number
    }>
  > =>
    httpClient.get(`/all-objects`, {
      params: {type},
    }),
  collectObjects: (
    data: AxiosRequestObjectCollectInterface
  ): Promise<AxiosResponse<any>> => httpClient.post(`/collect/mog`, data),
  getCollections: (): Promise<
    AxiosResponse<{collections: CollectionInterface[]}>
  > => httpClient.get(`/collections`),
  getHexagonInfo: (hexId: string): Promise<AxiosResponse<InformationOfHex>> =>
    httpClient.get(`/hexagons/${hexId}/info`),
  getPricesByHexes: (
    hex_ids: string[]
  ): Promise<AxiosResponse<{cost: {hex_id: string; cost: number}[]}>> =>
    httpClient.post(`/hexes-prices`, {hex_ids}),
  getDashboardOfAdvisor: (
    advisorId: number
  ): Promise<
    AxiosResponse<{
      u_advisor: AxiosResponseAdvisorWithCoordinatesInterface
    }>
  > => httpClient.get(`/advisors/${advisorId}`),
  postHexInOtherAdvisor: (
    data: AxiosRequestMoveHex
  ): Promise<AxiosResponse<{hex_ids: string[]; status: boolean}>> =>
    httpClient.post(`/advisors/move`, data),
}

export default MapService
